<template>
  <div
    class="checkin__child-course checkin-box"
    @click="handleClick"
  >
    <div class="contents-wrapper">
      <slot />
    </div>
    <div class="right-arrow" />
  </div>
</template>

<script>
export default {
  name:'SelfCheckinDialogItem',
  methods:{
    handleClick(){
      this.$emit('click');
    },
  },
};
</script>

<style lang='scss'>
</style>